export default "__VITE_ASSET__DyTrNVIP__"